import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';
import { CiSearch } from 'react-icons/ci';

import 'react-loading-skeleton/dist/skeleton.css';

import Card, { CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import Props from '@/components/shared/components/search/result/category/type';

import useCommonModalStore from '@/store/common-modal-store';

import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';
import localization, { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function CategoryItem({ title, count, id, find, index, linkId }: Props) {
  const { setShow } = useCommonModalStore();

  const handleCloseModal = () => {
    setShow(false);
  };
  const link = `/search?find=${find}&categories=${encodeURIComponent(JSON.stringify([id]))}`;
  return (
    <Link href={link} onClick={handleCloseModal} prefetch={false}>
      <Card
        noShadow
        center
        className={clsx(
          'w-full! flex-row items-center justify-start gap-3 rounded-none border-0! py-1',
          index < 2 && 'border-b! border-[#F4F5F6]',
          linkId,
        )}
      >
        <CardContent className='active::text-[#FF9606] flex h-12 w-full items-center justify-between rounded-lg! p-0 pr-2 pl-6 text-[#5B5C60] transition-all delay-300 hover:bg-[#FFF5E6] hover:text-[#FF9606] active:bg-[#FFF5E6]'>
          <Container className='flex items-center justify-start gap-[3px]'>
            <Text type={TEXT_TYPE.SPAN}>
              <CiSearch size={22} color={ICON_COLOR.gray} strokeWidth={0.5} />
            </Text>
            <Text className='text-sm text-[#5B5C60]' type={TEXT_TYPE.SPAN}>
              {localization.searchFor}
            </Text>
            <Text className='font-550! text-sm text-[#1F2025]' type={TEXT_TYPE.SPAN}>
              {find}
            </Text>
            <Text className='text-sm text-[#5B5C60]' type={TEXT_TYPE.SPAN}>
              {localization.in}
            </Text>
            <Text className='text-sm text-[#FF9606]' type={TEXT_TYPE.SPAN}>
              {title}
            </Text>
          </Container>
          <Container className='hidden md:inline'>
            <Text className='text-xs'>{productLocalization.productCount(count)}</Text>
          </Container>
        </CardContent>
      </Card>
    </Link>
  );
}
